<span
    class="inline-flex items-center gap-1 text-nowrap {{ fontSize }} {{ color }} font-normal {{ padding }} rounded-full border">
    @if (prefixIcon) {
    <i class="{{ prefixIcon }} {{ color }} mr-0.5"></i>
    }
    {{ label }}
</span>